'use client';
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb"
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import {Accordion, AccordionContent, AccordionItem, AccordionTrigger} from "@/components/ui/accordion";
import {cn} from "@/lib/utils";
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import * as z from 'zod'
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {Input} from "@/components/ui/input";
import {Textarea} from "@/components/ui/textarea";
import {Button} from "@/components/ui/button";
import {Send} from "lucide-react";

const nroUrgenceListe = [
    {title: 'Urgence médicale SAMU', contact: '185 ou 27.22.44.53.53'},
    {
        title: 'Pompiers',
        contact: '180 ou 07.07.81.18.18'
    },
    {
        title: 'Police secours',
        contact: '110/111/170'
    },
    {
        title: 'Défense nationale',
        contact: '199'
    }

];

const accordionItems = [
    {
        title: 'COVID',
        value: 'covid',
        content: <div>
            <p><strong>CONDITIONS D’ENTRÉE SUR LE TERRITOIRE IVOIRIEN</strong></p>
            <br/>
            <p>•Test covid-19</p>
            <br/>

            <p>RT-PCR : 48 heures avant la date du voyage</p> <br/>
            <p>Exceptions : Voyageurs entrant par la route ou tout autre moyen de transport terrestre. Vols en
                correspondance et escales : Un nouveau test RT-PCR doit être fourni si les voyageurs sont en transit
                pendant plus de 48 heures.&nbsp;</p> <br/>
            <p>• Vaccination</p> <br/> <p>Il est recommandé de se faire vacciner au moins 14 jours avant la date du
            voyage.
            Tous les vaccins doivent être approuvés par l’Organisation mondiale de la santé (OMS) ou par les autorités
            du pays où le voyageur a été immunisé.</p> <br/> <p>Les vaccins utilisés en Côte d’Ivoire sont les suivants
            :
            AstraZeneca, Pfizer, Janssen et Sinopharm.&nbsp;</p> <br/> <p><strong>Retrouver toutes les informations en
            temps
            réel sur la riposte à la pandémie à Covid-19 en Côte d’Ivoire en consultant le site suivant&nbsp;:
        </strong>&nbsp; <a href="http://info-covid19.gouv.ci/">http://info-covid19.gouv.ci/</a></p> <br/>
            <p>&nbsp;&nbsp;• NOUVELLE PROCEDURE DE VOYAGE PAR AVION EN COTE D’IVOIRE</p> <br/>
            <p>Dans le cadre de la réouverture des frontières aériennes ivoiriennes et la reprise des vols domestiques
                et internationaux, le Ministre des Transports informe la communauté aéroportuaire, les voyageurs et
                l’ensemble des usagers du transport aérien de la mise en place d’un nouveau système de déclaration du
                voyageur pour
                tous les vols.</p> <br/>
            <p>A cet effet, les voyageurs au départ, à l’arrivée et en transit en Côte d’Ivoire seront désormais soumis,
                en plus des mesures sanitaires liées à la covid-19, au renseignement d’un formulaire de Déclaration de
                Déplacement par Voie Aérienne (DDVA). Ce formulaire est disponible en ligne, via l’adresse : <br/>
                <a href="https://deplacement-aerien.gouv.ci">https://deplacement-aerien.gouv.ci</a></p> <br/> <p>Le
            Ministre
            des Transports insiste sur le caractère obligatoire de ce document qui est subordonné à l’embarquement et au
            débarquement des aéronefs. Le Ministre des Transports invite tous les candidats aux voyages à se conformer
            strictement aux présentes dispositions, afin de permettre des vols aériens en toute sécurité en cette
            période de crise sanitaire.</p> <br/> <h6><strong>Pour toute demande d’information relative aux tests
            covid-19,
            appeler les numéros suivants : 101, 105, 119, 125 ou 143 <br/>Pour toute difficulté relative à la
            déclaration de voyage, appeler les numéros suivants : +225 07 79 96 52 89 / +225 07 79 95 52 41 / +225 07 79
            79 71 41 / +225 07 79 91 00 25 / +225 07 79 90 02 82 / +225 07 79 79 70 98</strong></h6></div>
    },
    {
        title: 'Sécurité',
        value: 'securite',
        content: <>
            La Côte d’ivoire investit de plus en plus dans la sécurité publique. Le gouvernement a renforcé la sécurité
            dans les destinations touristiques, afin que les touristes qui ont l’intention de visiter le pays puissent
            se sentir en sécurité lorsqu’ils voyagent en Côte d’ivoire.
            <br/><br/>
            Débuté en 2017, le projet de vidéo-surveillance qui entre dans le cadre de la mise en place d’une
            plate-forme sécuritaire fait appel aux nouvelles technologies, pour réduire le taux de criminalité à travers
            notamment la mise en place d’un système de surveillance des infrastructures et d’un système de régulation et
            de contrôle de la circulation routière. Abidjan possède un réseau de plus de 1.024 caméras de surveillance
            et l’on constate une baisse de l’indice de sécurité de 1,6 à 1,1 contre 3,2 en 2011.
        </>
    },
    {
        title: 'Santé',
        value: 'sante',
        content: <div><p>Pour rentrer sur le territoire ivoirien, les autorités conseillent plusieurs vaccins notamment
            ceux contre :</p><br/><p>•&nbsp;&nbsp; La covid 19<br/>•&nbsp;&nbsp; &nbsp;<strong>La fièvre jaune, qui est
            obligatoire<br/></strong>•&nbsp;&nbsp; &nbsp;La méningococcie (facultatif)<br/>•&nbsp;&nbsp; &nbsp;La fièvre
            typhoïde (facultatif)<br/>•&nbsp;&nbsp; &nbsp;Les hépatites A et B (facultatif)<br/>•&nbsp;&nbsp; &nbsp;La
            poliomyélite (facultatif)</p><br/><p>Notons que les voyageurs qui ne se seraient pas acquittés de cette
            formalité
            avant leur venue pourront à leur descente d’avion être reçus par les services de l’hygiène publique. Le coût
            de ces vaccins revient à environ10 mille francs CFA, soit environ 15 euros par dose.</p><br/><p><strong><em>Astuces
            santé</em></strong></p><br/><p>Boire beaucoup d’eau. La Côte d’Ivoire est un pays tropical, nous vous
            recommandons donc de vous hydrater en permanence. Portez des vêtements confortables. Protégez votre peau du
            soleil en portant un chapeau, une casquette, des lunettes de soleil et de la crème solaire. Evitez de vous
            exposer au soleil entre 10h et 16h.&nbsp;</p><br/><p>La Côte d’Ivoire continue de suivre tous les protocoles
            sanitaires pour lutter contre le covid-19. Afin de réduire les risques de contamination, portez des masques
            de protection et lavez vous fréquemment les mains à l’eau et au savon. De plus, utilisez des désinfectants
            pour les mains contenant 70 % d’alcool, surtout après avoir utilisé les transports en commun ou visité des
            attractions touristiques.</p><br/></div>
    },
    {
        title: 'Formalités',
        value: 'formalites',
        content: <div>
            <p>Pour rentrer sur le territoire ivoirien, tout étranger doit être muni d´un passeport national, d´un
                laissez-passer ou d´un titre de voyage en cours de validité comportant au moins la photographie d´un
                titulaire, sur lequel a été apposé, au préalable, un visa biométrique d´entrée.</p><p><strong>Le visa
            biométrique</strong></p><br/><p>Le visa biométrique d´entrée en Côte d´Ivoire est soit un visa ordinaire
            soit un
            visa officiel. Le visa ordinaire est apposé dans le passeport ordinaire. Le visa officiel est apposé dans le
            passeport diplomatique, de service ou officiel.<br/>Qu´il soit ordinaire ou officiel, le visa biométrique
            d´entrée est donné, en fonction de la durée du séjour :<br/>•&nbsp;&nbsp; &nbsp;Un visa transit, ne peut
            excéder trois (03) jours;<br/>•&nbsp;&nbsp; &nbsp;Un visa court séjour, ne peut excéder trois (03)
            mois;<br/>•&nbsp;&nbsp; &nbsp;Un visa long séjour, ne peut excéder un (01) an.<br/>De même, le visa
            biométrique d´entrée est donné, en fonction du motif pour lequel, il est
            sollicité:<br/>•&nbsp;&nbsp; &nbsp;Un visa affaires;<br/>•&nbsp;&nbsp; &nbsp;Un visa
            études;<br/>•&nbsp;&nbsp; &nbsp;Un visa tourisme et loisirs;<br/>•&nbsp;&nbsp; &nbsp;Un visa santé et
            affaires sociales.<br/>Le visa biométrique d´entrée est délivré, à titre principal, par les représentations
            diplomatiques et consulaires à l´étranger et, exceptionnellement, à l´aéroport International Félix
            Houphouët-Boigny d´Abidjan et à tous autres postes-frontières.<br/>La procédure de délivrance du visa
            biométrique débute par le retrait du formulaire de demande de visa. Ce formulaire est disponible
            gratuitement aux lieux suivants :<br/>– Centre d´enrôlement et de délivrance de la Direction de la
            Surveillance du Territoire&nbsp;<br/>– Dans les Ambassades<br/>– Sur le site internet du concessionnaire
            agréé par l´Administration.<br/>Sous réserve de réciprocité, la prise de rendez-vous est obligatoire. Les
            frais perçus à cet effet et supportés par l´usager ne peuvent excéder trois mille trois cents (3.300) francs
            CFA convertibles en monnaie locale.<br/>Le prestataire chargé d´organiser le système de rendez-vous est
            choisi par le Directeur de la Surveillance du Territoire ou par l´Ambassade sur proposition de la
            SNEDAI&nbsp;<br/>Une fois le formulaire renseigné, le requérant se rend dans l´une des agences bancaires
            retenues, en vue de s´acquitter des droits de visa biométrique.<br/>Sous réserve de réciprocité, le visa
            officiel est gratuit.<br/>Sous réserve de réciprocité, les droits de visa biométrique ne s´appliquent qu´au
            visa ordinaire. Ces droits sont fixés à soixante-cinq mille six cents francs(65.600) CFA convertibles en
            monnaie locale.<br/>Le paiement des droits de visa biométrique donne lieu à la délivrance d´un reçu et d´un
            numéro d´opération.<br/>Il est définitif et ne donne droit à aucun remboursement même en cas de rejet de la
            requête pour quelque motif que ce soit.<br/>Une fois les droits acquittés, le requérant se rend au centre
            d´enrôlement et de délivrance muni des pièces requises.<br/>Il est procédé à la photographie et à la saisie
            des empreintes digitales, à la signature et aux renseignements des informations de personnalisation du
            requérant.<br/>Au terme de la procédure d´enrôlement, il est délivré au requérant un récépissé de dépôt de
            dossier de demande de visa biométrique.<br/>L´autorité de délivrance procède, s´il y à lieu, à l´instruction
            de la demande notamment en consultant le Ministre en charge de la Sécurité.<br/>Le délai de délivrance du
            visa biométrique est de quarante-huit heures(48) maximum à compter de la date d´enrôlement de
            l´intéressé.<br/>A ce délai s´ajoutent les délais de distance et d´instruction pour les requêtes
            subordonnées à l´avis favorable du Ministère en charge ou à une enquête préalable.<br/>le visa biométrique
            est apposé dans le passeport ou le titre de voyage. Il comporte le cachet du service Visa et la signature de
            l´autorité de délivrance.<br/>le mineur étranger, quel que soit son âge doit avoir un passeport personnel.
            La délivrance du visa biométrique se fait sur le lieu de l´enrôlement. Le visa n´est délivré qu´au titulaire
            contre décharge et sur la présentation du récépissé de dépôt de dossier de demande de visa.</p><br/><p>
            <strong>L’E-visa
                en trois étapes</strong></p><br/><p><strong>1 : le pré-enrôlement</strong></p><br/><p>Le demandeur du e-
            visa est tenu
            de se faire pré-enrôler en ligne sur le site de la snedaï (contact@snedai.ci).<br/>Il devra également
            choisir la durée du visa qu’il sollicite, remplir un formulaire avec toutes les informations requises.</p>
            <br/>
            <p><strong>2 : le paiement</strong></p><br/><p>Après le pré-enrôlement, le demandeur devra s’acquitter des
            frais
            pour l’obtention du e-visa à l’aéroport qui s’élève à :<br/>70 euros (hors frais bancaires) pour le visa
            court séjour qui ne peut excéder 3mois.<br/>130 euros (hors frais bancaires) pour le visa long séjour qui ne
            peut excéder 1an.<br/>Une option permettant le règlement des frais du e- visa sur le site au moment du
            pré-enrôlement en ligne est possible avec les cartes visa et Mastercard. Lorsque le paiement est fait, le
            requérant devrait recevoir un mail instantané, accompagné d’une pièce jointe sur laquelle figure le code
            unique et personnel d’attestation de paiement.<br/>Une seconde option permettant le règlement des frais est
            proposé cette fois à l’aéroport Félix Houphouët Boigny au niveau de la caisse du partenaire bancaire
            installée à proximité des postes de délivrance de l’e-visa biométrique. Dans ce cas –ci le visiteur a la
            possibilité de payer par carte bancaire ou en espèce) après quoi, un reçu lui est délivré.<br/>Notons que
            les cas de non-pré enrôlement en ligne sont exceptionnels et relèvent de la Direction de la Surveillance du
            Territoire (DST).</p><br/><p><strong>3 : Réception du document de confirmation (cas du pré-enrôlement en
            ligne)</strong></p><br/><p>A l’approbation de la demande, le demandeur de visa reçoit à son adresse
            électronique
            dans un délai de 48 heures maximum un document de confirmation ou « laissez-débarquer » (sur lequel figure
            un code à barre)&nbsp;qui reprend toutes les informations textuelles du demandeur de visa et fournit des
            informations quant à la procédure d’ajout des données biométriques (lieu, heures d’ouverture, document à
            emporter…).</p><br/><p>&nbsp;<strong>L’enrôlement à l´aéroport</strong></p><br/><p>Le demandeur embarque
            avec le «
            laissez-débarquer » et se présente à son arrivée à l’aéroport à l’espace « Visa aéroport ». Il y effectue
            son enrôlement biométrique et le visa est imprimé et délivré immédiatement. Les box d’enrôlement de l’E-visa
            sont disponibles 24h/24/7jours.<br/><strong><em>N.B :<br/></em></strong>– L’enrôlement (la prise
            d’empreintes et la photo) est obligatoire pour chaque demande de visa, même si le demandeur a déjà obtenu
            plusieurs visas.<br/>– Le visa biométrique requiert la présence du demandeur. La prise d’empreintes est
            obligatoire pour tous à l’exception des mineurs de moins de 12 ans, mais leur présence est nécessaire.</p>
            <br/>
            <p>L’original du reçu de paiement des frais du visa 70 Euros hors frais bancaire pour le court séjour et 130
                Euros hors frais bancaire pour &nbsp;le long séjour ;<br/>– L’approbation de la D.S.T. (pré-visa ou
                laissez-débarquer) ;<br/>– La réservation d’hôtel ou le certificat d’hébergement ;<br/>– Une
                autorisation parentale signée et légalisée du parent s’il s’agit d’un enfant mineur voyageant seul
                ;<br/>– Le passeport en cours de validité pour six mois minimum + la photocopie des trois premières
                pages (pages avec photo et adresse);&nbsp;<br/>– L’original de la copie intégrale ou l´extrait d´acte de
                naissance ;<br/>– La photocopie du certificat de scolarité ou de la carte d´étudiant (Elèves et
                Etudiants) ;<br/>– Le certificat international de vaccination contre la fièvre jaune ;&nbsp;<br/>– Une
                attestation détaillée de réservation de billet d’avion ou une photocopie du billet d´avion
                aller/retour.&nbsp;<br/>Joindre aux pièces déjà citées, selon le cas, les documents suivants :</p><br/>
            <p>
                <strong>Pour les mineurs&nbsp;</strong></p><br/><p>– Original de l´autorisation parentale légalisée
            (père, mère
            ou tuteur légal) ;</p><br/><p>– Justificatif d´identité du parent (père, mère ou tuteur légal) qui a donné
            l´autorisation de voyage (Passeport, Carte nationale d´identité ou Carte de séjour).&nbsp;</p><br/><p>
            <strong>Pour
                un visa affaires</strong></p><br/><p>•&nbsp;&nbsp; &nbsp;Lettre d’invitation
            ;<br/>•&nbsp;&nbsp; &nbsp;Justification de la qualité d’homme
            d’affaires<br/>•&nbsp;&nbsp; &nbsp;Confirmation de réservation d’hôtel
            ;<br/>•&nbsp;&nbsp; &nbsp; Justificatif de moyens financiers pour le séjour.</p><br/><p><strong>Pour un visa
            tourisme</strong></p><br/><p>•&nbsp;&nbsp; &nbsp;Confirmation de réservation d’hôtel où
            ;<br/>•&nbsp;&nbsp; &nbsp;Justificatif de moyens financiers pour le séjour.&nbsp;</p><br/></div>
    },
    {
        title: 'Numéros d\'urgence',
        value: 'numero_urgenc',
        content: <>
            Vous pouvez appeler ces numéros à partir de tout type de téléphone. La plupart d’entre eux sont disponibles
            24h/24 et 7j/7.
            <br/><br/>
            <table className={"table-auto w-full"}>
                <tbody>
                {nroUrgenceListe.map((item, index) => (
                    <tr key={index}>
                        <td className={cn("px-4 py-2 border border-slate-200 font-bold", {
                            "bg-slate-100": index % 2 === 0
                        })}>
                            {item.title}
                        </td>
                        <td className={cn("px-4 py-2 border border-slate-200", {
                            "bg-slate-100": index % 2 === 0
                        })}>
                            {item.contact}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </>
    },
    {
        title: 'Tension d\'alimentation/power voltage',
        value: 'tension_alimentation',
        content: <div><p><strong><em>Tension et fréquence en Côte d’Ivoire</em></strong></p><br/><p>Toutes les prises de
            courant en Côte d’Ivoire fournissent une tension standard de 230V avec une fréquence de 50Hz</p><br/><p>Vous
            pouvez utiliser tous vos appareils en Côte d’Ivoire si la tension standard dans votre pays est entre
            220V-240V. C’est surtout le cas en Europe, en Australie, au Belgique et dans la plupart des pays d’Afrique
            et d’Asie.</p><br/><p>Si la tension standard dans votre pays se situe entre 100V-127V (ce qui est plus
            courant
            aux Etats-Unis, au Canada et dans les pays d’Amérique du Sud), il vous faudra un convertisseur de tension en
            Côte d’Ivoire. Sans convertisseur, vous risquez d’endommager votre équipement électronique.</p><br/><p>La
            fréquence standard en Côte d’Ivoire est 50Hz.</p><br/><p>Si cette fréquence est différente de la fréquence
            de
            votre pays d’origine, nous ne vous recommandons pas d’utiliser vos appareils électronique en Côte
            d’Ivoire.</p><br/><p>Vous voyagez en Côte d’Ivoire ? Vérifiez rapidement si vous avez besoin d’un adaptateur
            secteur ou d’un convertisseur de tension en sélectionnant votre pays d’origine ci-dessus pour comparer les
            prises électriques et l’s fiches d’alimentation entre votre pays en la Côte d’Ivoire.</p><br/><h3>
            <strong><em>Fiches
                et prises électrique’ en Côte d’Ivoire</em></strong></h3><p>Les prises de courant et les fiches
            utilisées en
            Côte d’Ivoire sont de type C &amp; E. Jetez un coup d’œil aux photos ci-dessous pour voir à quoi ressemblent
            chaque fiche et chaque type de prise.</p><br/>
            <div className="flex justify-space-between">
                <div><p><img decoding="async" className="alignnone size-medium wp-image-1383"
                             src="/images/informations-utiles/typecfiche-300x201.png"
                             alt="" width="300" height="201"
                             sizes="(max-width: 300px) 100vw, 300px"/></p><br/>
                    <div>Type C fiche</div>
                </div>
                <div><p><img loading="lazy" decoding="async" className="alignnone size-medium wp-image-1384"
                             src="/images/informations-utiles/typeefiche-300x201.png"
                             alt="" width="300" height="201"
                             sizes="(max-width: 300px) 100vw, 300px"/>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </p><br/>
                    <div>Type E fiche</div>
                </div>
            </div>
            <p className="m-0"><strong>Type C</strong> – La prise européenne standard. Communément utilisé en Europe, en
                Amérique du Sud et en Asie, mais aussi dans un certain nombre d’autres pays. Les fiches de type E et F
                peuvent également être insérées dans une prise de type–C.</p><br/><p className="m-0"><strong>Type
                E</strong> – Principalement France, en Belgique, en Pologne, en Slovaquie et en République tchèque. Les
                fiches de type C et F s’adaptent également dans une prise de courant de type E.</p><br/></div>
    },
    {
        title: 'Météo et vêtements',
        value: 'meteo_vetements',
        content: <div><p>La Côte d’Ivoire est un pays au climat tropical. La Côte d’Ivoire est la zone de transition
            entre le climat équatorial humide et le climat tropical sec, ce qui permet au pays d’être divisé en deux
            zones principales : le sud et le nord.<br/>La différence entre ces deux parties se situe au niveau du taux
            d’hygrométrie qui peut parfois avoisiner 100% dans le sud et descendre à 20% dans le nord par temps
            d’harmattan (vent frais et sec en provenance du Sahara).<br/>Dans le sud,en dessous de Yamoussoukro, le
            climat est équatorial donc très humide. Avec des températures allant de 29° à 32° Celsius.<br/><br/></p><p>
            <strong><em>Vêtement conseillé</em></strong></p><br/><p>Préférez l’utilisation de vêtements légers et
            confortables. Il est également recommandé de se protéger du soleil avec un chapeau ou une casquette, des
            lunettes de soleil et de la crème solaire. Dans les zones boisées, nous recommandons l’utilisation de
            chaussures fermées et de chemises à manches longues (de préférence de couleurs claires), de pantalons longs
            et d’un chapeau pour se protéger des insectes.</p><br/><p><strong><em>Saisons de l’année en côte
            d’ivoire</em></strong></p><br/><p><strong>Quatre saisons se distinguent</strong>&nbsp;en général sur toute
            l’étendue du territoire :<br/>La grande saison des pluies : d’Avril à la mi-juillet, avec de fréquentes
            précipitations et de nombreux orages,<br/>La petite saison sèche : de la mi-juillet à Septembre, ou le ciel
            reste couvert,<br/>La petite saison des pluies : qui part de Septembre à Novembre, avec quelques petites
            précipitations et,<br/>La grande saison sèche : de Décembre à mars, marquée par les alizés du nord
            (harmattan).</p><br/><p><br/>Le nord, lui présente un climat tropical sec, avec des températures qui varient
            entre 28° et 37°Celsius. Ici l’on ne distingue que <strong>deux saisons</strong> principales :<br/>La grande
            saison des pluies allant de&nbsp;Juin à Septembre, due aux alizés humides et<br/>la grande saison sèche, qui
            part d’Octobre à Mai. </p><br/></div>
    },
    {
        title: 'Télécommunications',
        value: 'telecommunication',
        content: <div><p>L’indicatif téléphonique international de la Côte d’Ivoire est le +225.</p><br/>
            <p>Depuis le 1<sup>er</sup> Mars 2021, La numérotation à dix chiffres est effective partout en Côte d’Ivoire
                aussi bien pour les lignes fixes que pour les lignes mobiles. En fonction de l’opérateur choisi, les
                nouveaux préfixes varient.</p><br/>
            <p></p><br/>
            <div className="text-center"><img loading="lazy" decoding="async"
                                              className="alignnone size-medium wp-image-1382"
                                              src="/images/informations-utiles/telecomnumbers-e1642070567718-300x203.png"
                                              alt="" width="300" height="203"
                                              sizes="(max-width: 300px) 100vw, 300px"/></div>
            <p></p><br/>
            <p>L’utilisation de téléphones portables étrangers en Côte d’Ivoire dépend de la technologie utilisée et de
                la compatibilité avec les opérateurs Ivoiriens. Confirmez les conditions d’utilisation de votre
                téléphone portable en Côte d’Ivoire auprès de votre opérateur, car les tarifs d’utilisation du service
                varient.&nbsp;</p><br/></div>
    },
    {
        title: 'Langue',
        value: 'langue',
        content:
            <>
                La langue officielle de la Côte d’Ivoire est le français mais avec un accent et quelques expressions
                différentes. De nombreux Ivoiriens parlent anglais et il est également possible de trouver des personnes
                parlant couramment d’autres langues telles que l’espagnol, l’allemand, l’italien, le mandarin, l’arabe.
            </>
    },
    {
        title: 'Monnaie et change',
        value: 'monnaie_change',
        content:
            <div><p>La
                monnaie de la Côte d’Ivoire est le franc CFA et il peut être échangé dans les banques, les courtiers de
                change, les agences de voyages et certains hôtels agréés. Le taux de change est publié quotidiennement
                dans les lieux agréés et les sites Internet spécialisés.</p><br/><p>Il est recommandé de faire du change
                dans
                son pays en euros ou dollars US afin de faciliter les transactions une fois sur le territoire
                Ivoirien.</p><br/><p>Les «&nbsp;chèques de voyage&nbsp;» et les espèces s’échangent facilement dans les
                points de change. Les cartes de crédit internationales sont acceptées dans la plupart des hôtels,
                restaurants, magasins, agences de voyages, sociétés de location de voitures et autres entreprises qui
                fournissent des services aux touristes.</p><br/><p>Les vrais billets et pièces présentent des
                caractéristiques distinctives et des éléments de sécurité qui facilitent leur identification.</p><br/>
                <p>Pour
                    les billets de banque, le CFA a les coupures de 500 f, 1000 f, 2000 f, 5000 f et 10000 f.</p><br/>
                <p><img
                    loading="lazy" decoding="async" className="alignnone wp-image-1379"
                    src="/images/informations-utiles/billets-e1642070647218-300x92.png"
                    alt=""
                    width="567" height="173"
                    sizes="(max-width: 567px) 100vw, 567px"/></p><br/><p><strong>Connaître les pièces</strong></p><p>Les
                    pièces
                    de
                    monnaies ont des valeurs de 1 f, 2 f, 5 f, 10 f, 25 f, 50 f, 100 f et 500 f.</p><br/>
                <p><img loading="lazy"
                        decoding="async"
                        className="alignnone size-medium wp-image-1381"
                        src="/images/informations-utiles/pieces-300x154.png"
                        alt=""
                        width="300"
                        height="154"
                        sizes="(max-width: 300px) 100vw, 300px"/>
                </p><br/><p>&nbsp;</p></div>
    },
];

const schema = z.object({
    nom: z.string().min(1, "Le nom est obligatoire"),
    email: z.string().email("L'adresse email est invalide"),
    sujet: z.string().min(1, "Le sujet est obligatoire"),
    message: z.string().min(1, "Le message est obligatoire")
});

export default function Home() {

    const form = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            nom: "",
            email: "",
            sujet: "",
            message: ""
        }
    });

    const onSubmit = (data: any) => {
        console.log(data)
    }

    return (
        <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
            <CardTitle title={"Informations Essentielles"}
                       backgroundImgSrc={"/images/card-title/infos.jpg"}/>

            {/* Breadcrumb */}
            <SectionPage sectionType="2xl">
                <div className={"flex justify-between items-center"}>
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Informations Essentielles</BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>

                </div>
            </SectionPage>

            {/* Business & Leisure  */}
            <SectionPage sectionType="2xl">
                <AwesomeCard className={"bg-white text-muted-foreground"}
                             titleClassName={"text-bleu-marine"}>
                    <Accordion type="single" collapsible>
                        {accordionItems.map(item => (<AccordionItem key={item.value} value={item.value}>
                                <AccordionTrigger>{item.title}</AccordionTrigger>
                                <AccordionContent>
                                    {item.content}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>

                </AwesomeCard>
            </SectionPage>

            {/* contactez nous  */}
            <SectionPage sectionType="2xl">
                <AwesomeCard className={"bg-contactUs bg-cover text-muted-foreground text-white"}
                             title={"Contactez-nous"}
                             overlayClassName={"bg-bleu-marine opacity-60"}
                             titleClassName={"text-white"}>
                    <Form {...form}>
                        <form onSubmit={form.handleSubmit(onSubmit)} className={"grid grid-cols-1 md:grid-cols-2 gap-4"}>
                            <FormField
                                control={form.control}
                                name="nom"
                                render={({ field }) => (
                                    <FormItem>
                                        <FormLabel>Nom</FormLabel>
                                        <FormControl>
                                            <Input placeholder="Nom" {...field} className={"bg-white text-black border border-bleu-marine"} />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="email"
                                render={({ field }) => (
                                    <FormItem>
                                        <FormLabel>Email</FormLabel>
                                        <FormControl>
                                            <Input placeholder="Email" {...field} className={"bg-white text-black border border-bleu-marine"} />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="sujet"
                                render={({ field }) => (
                                    <FormItem className={"md:col-span-2"}>
                                        <FormLabel>Sujet</FormLabel>
                                        <FormControl>
                                            <Input placeholder="Sujet" {...field} className={"bg-white text-black border border-bleu-marine"} />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="message"
                                render={({ field }) => (
                                    <FormItem className={"md:col-span-2"}>
                                        <FormLabel>Message</FormLabel>
                                        <FormControl>
                                            <Textarea placeholder="Message" {...field} rows={6} className={"bg-white text-black border border-bleu-marine"} />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />
                            <div className="md:col-span-2">
                                <Button type={"submit"} className={"px-16 uppercase"} variant={"rose"}> <Send /> Envoyer</Button>

                                <p className={"text-center"}>
                                    Siège : Cocody Ambassade, derrière la Banque Mondiale
                                    <br/>
                                    <br/>
                                    01 BP 8538 ABIDJAN 01
                                    <br />
                                    Tél : + 225 27 22 22 41 10
                                    <br />
                                    Email : cote.ivoire.tourisme@gmail.com 
                                </p>
                            </div>
                        </form>
                    </Form>
                </AwesomeCard>
            </SectionPage>


        </div>
    );
}
